// Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
// Prakash 11/02/2022 3075234474 Added styling spacing  for Fields.
// Suresh Peddavoora 12/06/2022 2692790263 Added Styles for Select Dropdown Icon Alignments
// Prakash 12/23/2022 2701135832 Added fontsize for Autocomplete field.
// Rohini 02/09/2023 2698964415 Added the new classname and properties
// Prakash 02/13/2023 2698403495 added padding for cards.
// Guru Prasad 02/15/2023 2701135832 fixed styles for chips in Autocomplete field..
// Prakash 02/20/2023 2701135832 fixed alignment for dropdown.
// Prakash 13/04/2023 2701135832 remove margin-top
import {makeStyles} from '@material-ui/core';

const reusableInputStyles = makeStyles((theme) => ({
  cardStyling: {
    'whiteSpace': 'nowrap',
    'padding': '10px',
    'borderRadius': 8,
    'backgroundColor': '#ededed',
    'marginBottom': 10,
    'boxShadow':
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    '& .MuiTypography-h3': {
      padding: '3px 0 12px 0;',
    },
  },
  cardStyleWhite: {
    whiteSpace: 'nowrap',
    padding: '20px 15px 15px',
    borderRadius: 8,
    backgroundColor: '#fff',
    marginBottom: 10,
    boxShadow:
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
  },
  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '15px',
    borderRadius: 8,
    marginBottom: 10,
    backgroundColor: '#ededed',
    border: '2px solid #3e3e3e',
  },
  cardBordernoneStyles: {
    'whiteSpace': 'nowrap',
    'padding': '15px 10px',
    'borderRadius': '0px 0px 8px 8px',
    'backgroundColor': '#ffffff',
    'marginBottom': 10,
    'boxShadow':
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    '&.MuiGrid-spacing-xs-2': {
      margin: '0px -5px !important',
    },
    '& .MuiGrid-spacing-xs-2 ': {
      '& .MuiGrid-item': {
        padding: '0px 10px !important',
      },
    },
    '& .form-row': {
      '& .col': {
        paddingRight: '10px !important',
        paddingLeft: '10px !important',
      },
      '& [class*=col-]': {
        paddingRight: '10px !important',
        paddingLeft: '10px !important',
      },
    },
  },
  tabCardStyles: {
    whiteSpace: 'nowrap',
    padding: '15px',
    borderRadius: 8,
    backgroundColor: '#ededed',
    marginBottom: 10,
    boxShadow:
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
  },
  dialoguecardStyles: {
    'padding': '0px 15px',
    '& .MuiTypography-h4': {
      fontSize: '14px',
      fontFamily: 'articulat-cf, sans-serif !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
  dropDown: {
    zIndex: '11 !important',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      color: '#222222 !important',
      opacity: '1 !important',
      fontWeight: 'bold !important',
      margin: '15px 0 0',
    },
    '& fieldset': {
      'top': '0px !important',
      '& legend': {
        display: 'none !important',
      },
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.938rem',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.813rem !important',
        padding: '4px 14px! important',
      },
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
    },
  },
  textField: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.938rem',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px !important',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.813rem !important',
        padding: '3px 8px! important',
      },
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    '& .MuiAutocomplete-endAdornment': {
      // top: "20px",
    },
    '& .MuiSelect-iconOutlined': {
      top: '25px !important',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.938rem',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px !important',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.813rem !important',
        padding: '3px 8px! important',
      },
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
      paddingRight: '50px !important',
    },
  },
  // custom windows
  selectBox: {
    '& .MuiAutocomplete-endAdornment': {
      top: '10px !important',
    },
  },
  // custom windows
  selectdropdown: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      margin: '15px 0 0 ',
      [theme.breakpoints.down('sm')]: {
        margin: '10px 0 5px ',
      },
    },
    '& .MuiSelect-iconOutlined': {
      top: '20px !important',
      [theme.breakpoints.down('sm')]: {
        top: '21px !important',
      },
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.938rem',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px !important',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.813rem !important',
        padding: '3px 8px! important',
      },
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
      paddingRight: '50px !important',
    },
    '& .MuiSelect-select': {
      height: '1.1876em',
    },
  },
  // Recordformat-Label-fontsize//
  recordformatLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      [theme.breakpoints.down('md')]: {
        fontSize: '0.698rem !important',
      },
    },
  },
  // run a report
  selectrunadropdown: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      margin: '13px 0 0 ',
    },
    '& .MuiSelect-iconOutlined': {
      top: '25px !important',
      [theme.breakpoints.down('sm')]: {
        top: '21px !important',
      },
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.8rem !important',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px !important',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem !important',
      },
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
      paddingRight: '36px !important',
    },
  },
  // run a report rulegroup
  selectruledropdown: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      margin: '13px 0 0 ',
    },
    '& .MuiSelect-iconOutlined': {
      top: '25px !important',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.8rem !important',
      color: '#fff !important',
      width: '100%',
      padding: '3px 14px !important',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem !important',
      },
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
      paddingRight: '10px !important',
    },
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0 !important',
      'margin': '22px 0 0 !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },

    '& .MuiOutlinedInput-input': {
      fontSize: '16px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '500 !important',
      fontSize: '0.938rem',
      color: '#fff !important',
      width: '100%',
      padding: '3px 15px',
      backgroundColor: '#696969 !important',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      transform: 'translate(0, 0) scale(1) !important',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '10.5px !important',
      paddingBottom: '5.5px !important',
    },
    '& .MuiFormHelperText-root': {
      top: '55px !important',
    },
  },
  // DragAndDropWrapper: {
  //   "& .dropzone": {
  //     flexDirection: "row !important",
  //     alignItems: "center !important",
  //     padding: "12px !important",
  //     border: `2px dashed #5c5c5c`,
  //     backgroundColor: `transparent`,
  //     "& > p": {
  //       padding: "0px 10px 0px 0px",
  //     },
  //   },
  // },
  // radioGroup: {
  //   fontWeight: "bold",
  //   fontSize: "16px !important",
  // },
  listBox: {
    overflowY: 'auto !important',
    overflowX: 'hidden !important',
  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
  toolTip: {
    'zIndex': '10 !important',
    '& .MuiTooltip-tooltipPlacementBottom': {
      margin: '5px !important',
    },
  },
  buttonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px !important',
    },
    '& .MuiButton-label': {
      'fontSize': '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.688rem !important',
        letterSpacing: 1,
      },
      '& .MuiSvgIcon-root': {
        [theme.breakpoints.down('md')]: {
          fontSize: '1.1rem !important',
        },
      },
    },
  },
  option: {
    padding: '6px 16px',
    fontSize: '12px',
    [theme.breakpoints.down('md')]: {
      padding: '6px 10px',
      fontSize: '12px',
    },
  },
  dashboard: {
    padding: 0,
    marginBottom: 15,
    color: '#ffffff',
  },
  placementDate: {
    [theme.breakpoints.up('md')]: {
      '& .MuiOutlinedInput-input': {
        padding: '10.5px 5px',
      },
    },
  },
  globalButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },

  cardHeight: {
    minHeight: '480px',
  },
  systemNotesWrapper: {
    '& > .MuiPaper-root > .MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner > .MuiAccordion-region > .MuiAccordionDetails-root':
      {
        display: 'unset',
      },
  },
  mapRuleGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  globalPopup: {
    margin: '0 10px',
  },

  heading: {
    margin: '10px 15px',
  },
  searchText: {
    color: '#000000',
    fontSize: '16px',
    fontWeight: '900',
    marginBottom: '0',
  },
  firstCardDiv: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  secondCardDiv: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  letterControlButtons: {
    justifyContent: 'center',
    margin: '10px 0 15px',
  },
  htmlRadio: {
    '& .Mui-checked': {
      color: '#6200EE !important',
    },
    '& .MuiIconButton-colorSecondary': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  formRoot: {
    '& .MuiFormControl-root ': {
      '&.MuiFormControlLabel-root': {
        marginBottom: '0px !important',
        marginRight: '0px !important',
      },
    },
  },

  // letterControlButtons: {
  //   justifyContent: "center",
  //   margin: "10px 0 15px",
  // },
  // mapField: {
  //   margin: "0 12px",
  // },
  // globalButtons: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  //   marginBottom: "10px",
  // },
  globalField: {
    padding: '6px 8px',
    color: '#ffffff',
    marginBottom: '10px',
  },
  disabling: {
    opacity: '0.5 !important',
  },
  legend: {
    backgroundColor: '#ededed',
    position: 'absolute',
    top: -10,
    left: 15,
    color: '#222',
    padding: '2px 4px',
    fontWeight: 700,
    width: 'auto',
    fontSize: '14px',
    margin: '2px 0 10px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  },
  radioGroup: {
    'fontWeight': 'bold',
    'fontSize': '16px !important',
    '& .MuiFormControlLabel-root': {
      marginRight: '4px !important',
    },
  },
  DragAndDropWrapper: {
    '& .dropzone': {
      'flexDirection': 'row !important',
      'alignItems': 'center !important',
      'padding': '12px !important',
      'border': `2px dashed #5c5c5c`,
      'backgroundColor': `transparent`,
      '& > p': {
        padding: '0px 10px 0px 0px',
      },
    },
  },
  radioLabel: {
    fontWeight: '500 !important',
    fontSize: '0.938rem !important',
    color: '#fff !important',
    width: '100%',
    padding: '3px 15px !important',
    backgroundColor: '#696969',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    transform: 'translate(0, 0) scale(1) !important',
    marginBottom: '3px !important',
  },
  outputType: {
    'border': '1px solid #000',
    'height': '70px',
    'paddingLeft': '0px !important',
    'paddingRight': '0px !important',
    'borderRadius': '5px',
    'marginLeft': '5px',
    [theme.breakpoints.down('md')]: {
      height: '78px',
    },
    ' & .MuiFormGroup-row': {
      'paddingLeft': '14px',
      '& .MuiFormControlLabel-root': {
        [theme.breakpoints.down('md')]: {
          marginRight: '3px',
        },
      },
    },
  },
  buttonRoot2: {
    backgroundColor: '#D1D1D1',
    fontSize: '10px',
    borderRadius: '15px',
    marginTop: '20px',
    padding: '2px 16px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '8px',
      marginTop: '15px',
    },
  },
  addGlobalButtons: {
    textAlign: 'right',
    marginBottom: '7px',
  },
  filterGroupButton: {
    backgroundColor: '#D1D1D1',
    fontSize: '10px',
    borderRadius: '15px',
    marginTop: '19px',
    padding: 0,
  },
  multiselectlabel: {
    '& .MuiAutocomplete-tagSizeSmall': {
      'marginTop': '5px !important',
      'marginBottom': '5px !important',
      'height': '20px !important',
      [theme.breakpoints.up(1920)]: {
        marginTop: '22px !important',
      },
      '& .MuiChip-label': {
        // overflow:"visible !important",
        fontWeight: 'bold !important',
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    '& .MuiAutocomplete-tag': {
      marginTop: '15px !important',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '250px',
    },
    '& .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]': {
      padding: '10px 50px 0 8px !important',
    },
  },

  MTableAlign: {
    '& .MuiAccordionDetails-root': {
      display: 'inherit',
    },
  },
  mapRuleButton: {
    padding: '6px 5px !important',
  },
  iconSearch: {
    cursor: 'pointer',
  },
  checkRoot: {
    // margin: 0,
    marginTop: 5,
    marginLeft: -11,
    whiteSpace: 'pre-line',
    [theme.breakpoints.down('md')]: {
      ' & .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      },
    },
  },

  labelRoot: {
    '& .MuiTypography-root': {
      whiteSpace: 'pre-line',
    },
  },
  // Report Master CSS Starts //
  globalFieldTextfields: {
    'fontSize': '0.75rem !important',
    '& .MuiInputBase-inputMarginDense': {
      fontSize: '0.75rem !important',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '0.75rem !important',
      color: 'black !important',
    },
    '& .MuiInput-underline': {
      color: '#000000 !important',
    },
  },
  cardWrapper: {
    position: 'relative',
    overflow: 'visible !important',
    padding: '15px',
    boxShadow: ' none !important',
    border: '1px solid rgb(207, 207, 207)',
    borderRadius: '8px !important',
    margin: '8px 0px 30px',
  },
  labelLegend: {
    position: 'absolute',
    top: '-15px',
    borderRadius: '4px',
    backgroundColor: '#ebebeb',
    padding: '5px 10px',
    color: '#056c93',
    fontWeight: '600',
    fontSize: '12px',
  },
  labelText: {
    fontSize: '12px',
    fontWeight: '500',
    marginRight: '10px',
  },
  fieldLabel: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
  },
  checkBox: {
    'width': '100%',
    '& .MuiIconButton-label': {
      zoom: '0.8',
    },
  },
  formLabel: {
    lineHeight: 1.5,
    letterSpacing: '0.5px',
    fontSize: '0.875rem !important',
    fontWeight: '600 !important',
    color: '#707070 !important',
    // whiteSpace: "pre-wrap !important",
  },
  textComponent: {
    '& .MuiOutlinedInput-root': {
      width: '60px',
    },
  },
  dateField: {
    width: '65%',
  },
  autocompleteField: {
    width: '25%',
  },
  // select-field-css-starts//
  selectField: {
    '& .MuiFormLabel-root': {
      fontSize: '14px !important',
    },
    '& .MuiSelect-select': {
      padding: '0px !important',
      paddingLeft: '14px !important',
      minHeight: '2.45em !important',
      fontSize: '14px !important',
      fontFamily: 'articulat-cf, sans-serif !important',
      color: '#595959',
    },
    '& .MuiSelect-nativeInput': {
      padding: '10px !important',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1) !important',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important',
    },
  },
  // select-field-css-ends//

  // Report Master CSS Ends //
}));

export default reusableInputStyles;
